var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyWebsiteSessionsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 70",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.455 40.727c0 14.761-11.967 26.728-26.728 26.728C11.967 67.455 0 55.488 0 40.727 0 25.967 11.966 14 26.727 14c14.761 0 26.728 11.966 26.728 26.727",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.182 33.09c0 17.573-14.246 31.82-31.818 31.82-17.573 0-31.819-14.247-31.819-31.82 0-17.572 14.246-31.817 31.819-31.817 17.572 0 31.818 14.245 31.818 31.818",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.364 66.182a33.122 33.122 0 01-15.68-3.946 1.272 1.272 0 111.208-2.238 30.606 30.606 0 0014.472 3.638c16.843 0 30.545-13.703 30.545-30.545 0-16.842-13.702-30.546-30.545-30.546-15.844 0-29.22 12.359-30.452 28.134a1.26 1.26 0 01-1.368 1.17 1.272 1.272 0 01-1.17-1.368C16.709 13.389 31.2 0 48.365 0c18.246 0 33.09 14.844 33.09 33.091s-14.844 33.09-33.09 33.09",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.364 2.545c-8.28 0-15.273 13.988-15.273 30.546s6.994 30.545 15.273 30.545S63.636 49.65 63.636 33.091 56.643 2.545 48.364 2.545m0 63.637c-9.992 0-17.818-14.536-17.818-33.091S38.372 0 48.364 0s17.818 14.536 17.818 33.091-7.826 33.09-17.818 33.09",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.364 66.182a1.272 1.272 0 01-1.273-1.273V1.273a1.272 1.272 0 112.545 0v63.636c0 .704-.57 1.273-1.272 1.273",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.058 22.91H18.67a1.272 1.272 0 110-2.546h59.388a1.272 1.272 0 110 2.545M78.058 45.818H28a1.272 1.272 0 110-2.545h50.058a1.272 1.272 0 110 2.545",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.545 50.91c-5.15 0-11.454 3.78-11.454 6.363v6.363C5.09 66.22 11.395 70 16.545 70 21.696 70 28 66.219 28 63.636v-6.363c0-2.583-6.304-6.364-11.455-6.364",
    fill: "#E74A10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 64.91a1.272 1.272 0 01-1.273-1.274v-6.363c0-1.517-5.326-5.091-10.182-5.091-4.855 0-10.181 3.574-10.181 5.09v6.364a1.272 1.272 0 11-2.546 0v-6.363c0-3.79 7.405-7.637 12.727-7.637 5.323 0 12.728 3.848 12.728 7.637v6.363c0 .704-.57 1.273-1.273 1.273",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.545 35.636c-3.29 0-6.363 2.462-6.363 5.5v4.274c0 3.038 3.073 5.5 6.363 5.5 3.29 0 6.364-2.462 6.364-5.5v-4.274c0-3.038-3.074-5.5-6.364-5.5",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.545 36.91c-2.712 0-5.09 1.974-5.09 4.225v4.275c0 2.251 2.378 4.226 5.09 4.226 2.713 0 5.091-1.975 5.091-4.226v-4.275c0-2.25-2.378-4.226-5.09-4.226m0 15.273c-4.14 0-7.637-3.102-7.637-6.772v-4.275c0-3.67 3.498-6.771 7.636-6.771 4.14 0 7.637 3.101 7.637 6.77v4.276c0 3.67-3.498 6.772-7.637 6.772",
    fill: "#020303"
  }))));
}
export default SvgWhyWebsiteSessionsIcon;